<div class="message-templates-dialog">
  <div mat-dialog-title oneDialogTitle>
    <span *ngIf="messageType === 'Email'" i18n="@@input-dialog-example.title">Message templates</span>
    <span *ngIf="messageType === 'Reminder'" i18n="@@input-dialog-example.title">Reminder templates</span>
  </div>
  <div mat-dialog-content oneDialogContent class="import-dialog-content">
    <mat-form-field appearance="outline" oneFormField>
      <mat-label>Subject</mat-label>
      <input matInput value="" [formControl]="msgTemplateSubjectFormControl" (keyup)="onKeyupSubjectName($event)" (blur)="onBlurSubjectName($event)" min="5" max="255" />
      <button mat-icon-button one-icon-button matSuffix (click)="msgTemplateSubjectFormControl.setValue('')">
        <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix>clear </mat-icon>
      </button>
    </mat-form-field>
    <dl-rich-text-document [jsonTextItem]="textDoc" [showInEditor]="" (jsonTextReturn)="setRTETextadd($event)"></dl-rich-text-document>

  </div>
  <div mat-dialog-actions oneDialogActions class="import-dialog-actions">
    <button one-secondary-button
            mat-stroked-button
            [mat-dialog-close]="true">
      Cancel
    </button>
    <!--*ngIf="templateData.templateId; else createTemplate"  (click)="newTemplateClicked()" -->
    <button color="primary" [disabled]="isSaveBtnDisabled" mat-flat-button i18n="@@input-dialog-example.ok-btn" (click)="updateMsgTemplate()">
      Save
    </button>
  </div>
</div>
